import React, {Component} from "react";
import { Button, Popover, OverlayTrigger } from "react-bootstrap";

const ConfirmButton = ({text, bsStyle, bsSize, style, ...rest}) => (
  <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={<ConfirmPopover {...rest} />} >
    <Button bsStyle={bsStyle || "info"} bsSize={bsSize || "xsmall"} style={style}>{text}</Button>
  </OverlayTrigger>
)

class ConfirmPopover extends Component {
  constructor(props) {
    super(props)
    this.state = { note: '', error: '' }
  }

  handleChange = (event) => {
    const note = event.target.value;
    this.setState({ note, error: '' })
  }

  handleSubmit = () => {
    const { okAction, hideNote, requireNote, minLength = 15 } = this.props;
    const { note } = this.state;

    // If note is not hidden and is required, validate it
    if (!hideNote && requireNote !== false) {
      if (!note || note.trim().length === 0) {
        this.setState({ error: 'Note is required' });
        return;
      }
      if (note.trim().length < minLength) {
        this.setState({ error: `Note must be at least ${minLength} characters` });
        return;
      }
    }

    document.body.click();
    okAction(note);
  }

  render() {
    const { okAction, message, hideNote, style, requireNote, minLength = 15, ...rest } = this.props
    const { error } = this.state;

    return (
      <Popover {...rest} id="tooltip-trigger-focus" className='warning' title="Are you sure?">
        <div className='form-group'>
        {message && <p>{message}</p>}
        {!hideNote && (
          <>
            <textarea 
              className='form-control' 
              onChange={this.handleChange} 
              placeholder={requireNote !== false ? `Add a note (min ${minLength} characters)` : 'add a quick note?'}
            ></textarea>
            {error && <small style={{ color: 'red', display: 'block', marginTop: 4 }}>{error}</small>}
          </>
        )}
        </div>
        <div>
        <Button style={{ marginRight: 2 }} bsStyle="default" onClick={() => document.body.click()}>Cancel</Button>

          <Button className='pull-right' style={{ marginRight: 2 }} bsStyle="info" onClick={this.handleSubmit}>Yes, Go Ahead</Button>
        </div>
      </Popover >)
  }
}

export default ConfirmButton